import { render, staticRenderFns } from "./NotificationBar.vue?vue&type=template&id=027de4f0&scoped=true"
import script from "./NotificationBar.vue?vue&type=script&lang=ts"
export * from "./NotificationBar.vue?vue&type=script&lang=ts"
import style0 from "./NotificationBar.vue?vue&type=style&index=0&id=027de4f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027de4f0",
  null
  
)

export default component.exports